var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.49 4.49 0 10 0C15.51 0 20 4.49 20 10C20 15.51 15.51 20 10 20C4.49 20 0 15.51 0 10ZM9.25 10.75H14C14.41 10.75 14.75 10.41 14.75 10C14.75 9.59 14.41 9.25 14 9.25H10.75H6C5.59 9.25 5.25 9.59 5.25 10C5.25 10.41 5.59 10.75 6 10.75H9.25Z",
    fill: "#FCEEE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minus-icon.9b2982f722b3d023d2c73d32c1903eda.svg";
export { ForwardRef as ReactComponent };